import React, { useState, useEffect } from 'react';
import { Card, CardGroup, Container, Row, Col } from 'react-bootstrap';

import "./CountdownTimer.css"

const CountdownTimer = ({ targetDate }) => {  // Pass ISO date like '2026-03-15T09:00:00'
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = new Date(targetDate).getTime() - now;
      if (distance < 0) {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  const units = [
    { value: timeLeft.days, label: 'DNI' },
    { value: timeLeft.hours, label: 'GODZIN' },
    { value: timeLeft.minutes, label: 'MINUT' },
    { value: timeLeft.seconds, label: 'SEKUND' },
  ];

  return (
    <div className="countdownContainer">
        {units.map(({ value, label }, index) => (
        <div key={index} className="countdownSection">
          <span className="countdownValue">{value.toString().padStart(2, '0')}</span>
          <span className="countdownLabel">{label}</span>
        </div>
        ))}
    </div>
  );
}

export default CountdownTimer;
